import { useEffect } from 'react';
/**
 * Custom hook to manage the browser tab title
 * @param options Configuration options for the document title
 */
export function useDocumentTitle(options) {
    const { title, suffix = 'Tailly', restoreOnUnmount = true } = options;
    useEffect(() => {
        // Store the original title to restore later if needed
        const originalTitle = document.title;
        // Set the new title with optional suffix
        const newTitle = suffix ? `${title} | ${suffix}` : title;
        document.title = newTitle;
        // Cleanup function to restore original title
        return () => {
            if (restoreOnUnmount) {
                document.title = originalTitle;
            }
        };
    }, [title, suffix, restoreOnUnmount]);
}
/**
 * Simplified version of useDocumentTitle for quick usage
 * @param title The title to set
 */
export function usePageTitle(title) {
    useDocumentTitle({ title });
}
